import React, { useState } from "react";
import axios from "axios";

const JiraIntegrationPopupNoInstances = (props) => {
  const [disable, setDisable] = React.useState(false);
  const openInNewTab = (url) => { const newWindow = window.open(url, '_blank');
    if (newWindow) newWindow.opener = null;
  };

  const getNewJiraOauth2Connections = () => {
    console.log("url: " + `${wbConfig.baseUrl}/integration/getAllInstances` );
    const timer = setInterval(function () {
      axios
      .get(`${wbConfig.baseUrl}/integration/getAllInstances`, {
        params: {
          app: 'jira'
        }
      })
      .then(response => 
        {
          if (response.data && response.data.data && response.data.data.length > 0) {
            clearInterval(timer);
            props.updateParentState(response.data.data[0].belong_to);
            // Place to improve:  "props.closePopup(true);" for ws import
          }
        });
    }, 2000); // do it every 2000 milliseconds until close
  };

  const updateOAuth2Connection = () => {
    setDisable(true); 
    openInNewTab(props.data.jiraOauth2Url); 
    getNewJiraOauth2Connections(props);
  }

  if (props.data.isJiraOAuth2 && (props.data.jiraInstances.length==0)) {
    return (
      <div className="login-jira-no-instances">
        <div className="login-jira-body">
          <div className="login-jira-details">
            {'Your organization is configured to use OAuth2 for Jira \
                  integration. Click continue to complete the Jira integration process.'}
          </div>
        </div>
        <div className="login-jira-footer">
          <input type="button" value="Continue" className="connect-button" disabled={disable}
            onClick={ () => updateOAuth2Connection() } />
        </div>
      </div>
    );
  } else {
    return (
      <div className="login-jira-no-instances">
        <div className="login-jira-body">
          <div className="login-jira-details">
            {'Your organization is configured to use OAuth1 for Jira \
                  integration. Contact your WorkBoard administrator to connect a \
                  Jira instance. If you have Jira administrator privileges, click \
                  continue to complete the Jira integration process.'}
          </div>
        </div>
        <div className="login-jira-footer">
          <input type="button" value="Continue" className="connect-button"
            onClick={() => props.setAddAnother(true)} />
        </div>
      </div>
    );
  }
};

export default JiraIntegrationPopupNoInstances;
